export const addressType = {
  LOC: 'Location',
  COR: 'Corporate',
  OFF: 'Legal',
  ADD: 'Additional',
}
